<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import QRBuhoCampaignForm from './QRBuhoCampaignForm.vue';

const emit = defineEmits(['close']);
const { t } = useI18n();
const store = useStore();

const handleSubmit = async formData => {
  try {
    // El formData ya viene como FormData desde el form, pasarlo directamente
    await store.dispatch('campaigns/create', formData);

    useAlert(t('CAMPAIGN.QRBUHO.CREATE.FORM.API.SUCCESS_MESSAGE'));
    emit('close');
  } catch (error) {
    useAlert(t('CAMPAIGN.QRBUHO.CREATE.FORM.API.ERROR_MESSAGE'), 'error');
  }
};

const handleClose = () => emit('close');
</script>

<template>
  <div
    class="w-[25rem] z-50 min-w-0 absolute top-10 ltr:right-0 rtl:left-0 bg-n-alpha-3 backdrop-blur-[100px] p-6 rounded-xl border border-n-weak shadow-md flex flex-col gap-6"
  >
    <h3 class="text-base font-medium text-n-slate-12">
      {{ t('CAMPAIGN.QRBUHO.CREATE.TITLE') }}
    </h3>
    <QRBuhoCampaignForm @submit="handleSubmit" @cancel="handleClose" />
  </div>
</template>
